module.exports = {
	"pagination": {
		"ListAssessmentRunAgents": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"ListAssessmentRuns": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"ListAssessmentTargets": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"ListAssessmentTemplates": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"ListEventSubscriptions": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"ListFindings": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"ListRulesPackages": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"PreviewAgents": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/aws-sdk/apis/inspector-2016-02-16.paginators.json
// module id = 1633
// module chunks = 4